<template>
  <span class="vuestic-tooltip-target" v-tooltip="tooltipOptions">
      <slot></slot>
  </span>
</template>

<script>
import { VTooltip } from 'v-tooltip'

export default {
  name: 'vuestic-tooltip',

  directives: { tooltip: VTooltip },

  computed: {
    tooltipOptions () {
      return Object.assign({}, this.defaultOptions, this.options)
    },
  },

  props: {
    options: {
      type: Object,
      default: () => [],
    },
  },

  data () {
    return {
      defaultOptions: {
        classes: 'vuestic-tooltip',
      },
    }
  },
}
</script>

<style lang='scss'>

.toolTipHelp{
  color: $brand-primary;
  cursor: help;
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: Source Sans Pro,sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 1rem;
    word-wrap: break-word;
    opacity: 0.9;
}

.tooltip.vuestic-tooltip {
  
  .tooltip-inner {
    line-height: 1.13;
    font-weight: 300;

    max-width: 40rem;
    padding: 5px 10px 5px;
    color: #fff;
    text-align: center;
    background-color: #333;
    border-radius: 16px;
    text-align: left;
  }

  .tooltip-arrow {
    position: absolute;
    display: block;
    width: .8rem;
    height: .4rem;
  }

  &[x-placement^="right"] {
  	margin-left: .15rem;
  }

  &[x-placement^="left"] {
  	margin-right: .15rem;
  }

  &[x-placement^="top"] {
    padding: .4rem 0;
  }

  &[x-placement^="bottom"] {
    padding: .4rem 0;
  }

  &[x-placement^="bottom"] .tooltip-arrow {
    top: 0;
  }

  &[x-placement^="top"] .tooltip-arrow {
    bottom: 0;
  }

  &[x-placement^="right"] .tooltip-arrow {
    left: 0;
    width: .4rem;
    height: .8rem;
  }

  &[x-placement^="left"] .tooltip-arrow {
    right: 0;
    width: .4rem;
    height: .8rem;
  }

  &[x-placement^="left"] .tooltip-arrow:before {
    left: 0;
    border-width: .4rem 0 .4rem .4rem;
    border-left-color: #333;
  }
  
  &[x-placement^="right"] .tooltip-arrow:before {
    right: 0;
    border-width: .4rem .4rem .4rem 0;
    border-right-color: #333;
  }
  
  &[x-placement^="top"] .tooltip-arrow:before {
    top: 0;
    border-width: .4rem .4rem 0;
    border-top-color: #333;
  }
  
  &[x-placement^="bottom"] .tooltip-arrow:before {
    bottom: 0;
    border-width: 0 .4rem .4rem;
    border-bottom-color: #333;
  }

}
</style>
